import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class ProcessViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const view = this.getView(route);
    if (view) {
      this.routeGuardService.handleRoute(view);
    }
    return true;
  }

  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    const queryParams = route?.queryParams || {};
    let queryString = '';

    // Build query string from query parameters
    if (queryParams && Object.keys(queryParams).length > 0) {
      const params = new URLSearchParams();
      for (const key in queryParams) {
        if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
          params.append(key, queryParams[key]);
        }
      }
      queryString = '?' + params.toString();
    }

    return {
      route: `process/${uuid}${queryString}`,
      iframeUrl: `process/${uuid}${queryString}`,
    };
  }
}
